export default __webpack_public_path__ + "assets/images/3f7409846885f66efe406a7f803eee4e.jpg";